import ContactPage from '../pages/ContactPage';

import Aboutus from '../markup/Pages/Aboutus';
import Blogdetail from '../markup/Pages/Blogdetail';
import { Homepage } from '../pages/Home/Homepage';
import { StudentsAndGraduates } from '../pages/StudentsAndGraduates';
import { CareerCounselingPage } from '../pages/CareerCounselingPage';
import { BrowseJobFilterGrid } from '../pages/Job/BrowseJobFilterGrid';
import { JobDetail } from '../pages/Job/JobDetail';
import { NotFound } from '../pages/Static/NotFound';

/**
 * Rutas públicas - Accesibles para todos (autenticados o no)
 * Incluyen Layout (Header/Footer)
 */
export const publicRoutes = [
    {
        path: '/',
        exact: true,
        component: Homepage,
        name: 'Inicio',
        description: 'Página principal'
    },
    {
        path: '/home',
        exact: true,
        component: Homepage,
        name: 'Inicio',
        description: 'Página principal (alias)'
    },
    {
        path: '/about-us',
        exact: true,
        component: Aboutus,
        name: 'Quiénes Somos',
        description: 'Página sobre nosotros'
    },
    {
        path: '/students-and-graduates',
        exact: true,
        component: StudentsAndGraduates,
        name: 'Estudiantes y Egresados',
        description: 'Información para estudiantes y egresados'
    },
    {
        path: '/career-counseling',
        exact: true,
        component: CareerCounselingPage,
        name: 'Asesoría Laboral',
        description: 'Servicios de asesoría laboral'
    },
    {
        path: '/browse-job-filter-grid',
        exact: true,
        component: BrowseJobFilterGrid,
        name: 'Buscar Vacante',
        description: 'Buscar vacante por filtros'
    },
    {
        path: '/job-detail',
        exact: true,
        component: JobDetail,
        name: 'Detalle de Vacante',
        description: 'Detalle de una vacante específica'
    },
    {
        path: '/blog-details',
        exact: true,
        component: Blogdetail,
        name: 'Detalle del Blog',
        description: 'Detalle específico del blog'
    },
    {
        path: '/contact',
        exact: true,
        component: ContactPage,
        name: 'Contacto',
        description: 'Página de contacto'
    },
    {
        path: '*',
        component: NotFound,
        name: 'Página No Encontrada',
        description: 'Página 404 - No encontrada'
    },
];
